import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../../Common/PlaceholderWrapper";
import i18next from "i18next";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";

class DelegateScheduleVacation extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            showEditForm: false, rowKey: null, isDataSaved: true
        }
    }

    componentDidMount() {
        this.initialize();
    }

    async initialize() {
        try {
            let key = {NumYear: this.props.currentYear};
            await this.props.dispatch(this.props.SchedHolidayYearDeleg_DescPO.execute(key));
            await this.props.dispatch(this.props.SchedHolidayYearDelegHist_ListPO.execute(key, {withStyle: true}));
        } catch (e) {
            await this.props.dispatch(e);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.currentYear !== prevProps.currentYear) {
            this.initialize();
        }
    }

    onRefresh = async () => {
        try {
            await this.props.dispatch(this.props.SchedHolidayYearDeleg_DescPO.refresh());
            await this.props.dispatch(this.props.SchedHolidayYearDelegHist_ListPO.refresh());
        } catch (e) {
            await this.props.dispatch(e);
        }
    }

    createDelegation = async (event) => {
        event.preventDefault();
        await this.props.dispatch(this.props.SchedHolidayYearDeleg_DescPO.beginAdd());
        this.setState({rowKey: null, showEditForm: true});
    }

    hideDelegation = async () => {
        this.setState({showEditForm: false});
        await this.onRefresh();
    }

    saveDelegation = async (event) => {
        this.setState({isDataSaved: false});
        try {
            event.preventDefault();
            await this.props.dispatch(this.props.SchedHolidayYearDeleg_DescPO.save(0));
            if (this.props.SchedHolidayYearDeleg_DescPO.isError) {
                return;
            }
            await this.props.dispatch(this.props.SchedHolidayYearDelegHist_ListPO.refresh());
        } finally {
            this.setState({isDataSaved: true});
        }
    }

    deleteDelegation = async (event) => {
        this.setState({isDataSaved: false});
        try {
            event.preventDefault();
            await this.props.dispatch(this.props.SchedHolidayYearDeleg_DescPO.setField(0, 'DelegFIO', null));
            await this.props.dispatch(this.props.SchedHolidayYearDeleg_DescPO.setField(0, 'DelegTabNum', null));
            await this.props.dispatch(this.props.SchedHolidayYearDeleg_DescPO.save(0));
            if (this.props.SchedHolidayYearDeleg_DescPO.isError) {
                return;
            }
            await this.props.dispatch(this.props.SchedHolidayYearDelegHist_ListPO.refresh());
        } finally {
            this.setState({isDataSaved: true});
        }
    }

    renderParams = (h) => {
        const isDelegating = this.props.SchedHolidayYearDeleg_DescPO.rowsCount() > 0 && this.props.SchedHolidayYearDeleg_DescPO.getField(0, 'DelegTabNum');
        return (<div className="row">
            <div className="col-md-12">
                {h.fs.map(fld => {
                    return (<React.Fragment key={fld.fieldInfo.Name}>
                        <div className="row">
                            <div className="col-md-3 text-md-right field-title">
                                {h.lbl(fld.Name)}
                            </div>
                            <div className="col-md-9">
                                {h.ed(fld.Name)}
                            </div>
                        </div>
                        <hr/>
                    </React.Fragment>)
                })}
                {!this.state.isDataSaved && isDelegating && <button type="button"
                                                                    className="btn btn-regular -goahead ml1ex mb-2"
                                                                    onClick={this.saveDelegation}
                                                                    disabled={false}>{i18next.t("Save")}</button>}
                {this.state.isDataSaved && isDelegating && <button type="button"
                                                                   className="btn btn-regular ml1ex mb-2"
                                                                   onClick={this.deleteDelegation}
                                                                   disabled={false}>{i18next.t("Delete")}</button>}
            </div>
        </div>)
    }

    render() {
        return (<>
                <PlaceholderWrapper placeholderId="DelegateScheduleVacation_10"
                                    title={<><i className='fa fa-file-text-o'/> {i18next.t("Delegate_Schedule_Vacation_1")}</>}
                                    showSplitterLine={false} canCollapse={true}>
                    <ComplexParam dataItem={this.props.SchedHolidayYearDeleg_DescPO} showSearchBar={false}
                                  showApplyButton={false} autoApplyParams={false} onEndEditField={() => {
                        this.setState({isDataSaved: false});
                    }}
                                  renderParams={this.renderParams}
                    />
                    <PlaceholderWrapper placeholderId="DelegateScheduleVacation_20"
                                        title={<><i className='fa fa-file-text-o'/> {i18next.t("RVD_Request_2")}</>}
                                        collapsed={true}
                                        showSplitterLine={false} canCollapse={true}>
                        <GridView dataItem={this.props.SchedHolidayYearDelegHist_ListPO} allowPagination={true}
                                  readOnly={true}
                                  pageSize={10}
                                  useItemStyle={true}/>
                    </PlaceholderWrapper>
                </PlaceholderWrapper>
            </>)
    }
}

DelegateScheduleVacation.propTypes = {
    dispatch: PropTypes.func.isRequired,
    currentYear: PropTypes.number,
    SchedHolidayYearDeleg_DescPO: PropTypes.object,
    SchedHolidayYearDelegHist_ListPO: PropTypes.object
}

DelegateScheduleVacation.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        SchedHolidayYearDeleg_DescPO: state.vacationState.SchedHolidayYearDeleg_DescPO,
        SchedHolidayYearDelegHist_ListPO: state.vacationState.SchedHolidayYearDelegHist_ListPO
    }
}

export default connect(mapStateToProps)(DelegateScheduleVacation);